import { gql } from '@apollo/client';

export const SEARCH_VEHICLES_QUERY = gql`
  query Query($input: InventorySearchInput!) {
    inventorySearch(input: $input) {
      ... on InventorySearchSemanticPayload {
        groups {
          ... on InventorySearchSemanticGroupSuccess {
            key
            totalCount
            vehicles {
              id
              vin
              title
              subtitle
              modelName
              modelYear
              carPrices {
                label
                type
                price {
                  value
                  valueAsText
                  formattedValue
                  currencyDetails {
                    code
                    symbol
                  }
                }
                disclaimers {
                  id
                  text
                  legalEntityKey
                }
              }
              exteriorColor
              odometerText
              odometerValue
              dealer {
                id
                name
                region
              }
              imageUrl
              weblink
              stockType
            }
            searchTraces {
              stockIdentifier {
                brand
                country
                language
                stockCarsType
              }
              criteria {
                id
                items
              }
              specialCriteria {
                id
                items
              }
              sort {
                id
                direction
              }
            }
            vlpLink
          }
          ... on InventorySearchSemanticGroupFailure {
            key
            reason
            code
            searchTraces {
              stockIdentifier {
                brand
                country
                language
                stockCarsType
              }
              criteria {
                id
                items
              }
              specialCriteria {
                id
                items
              }
              sort {
                id
                direction
              }
            }
          }
        }
        warnings {
          code
          message
        }
      }
      ... on InventorySearchLookupPayload {
        vehicles {
          id
          vin
          title
          subtitle
          modelName
          modelYear
          carPrices {
            label
            type
            price {
              value
              valueAsText
              formattedValue
              currencyDetails {
                code
                symbol
              }
            }
            disclaimers {
              id
              text
              legalEntityKey
            }
          }
          exteriorColor
          odometerText
          odometerValue
          dealer {
            id
            name
            region
          }
          imageUrl
          weblink
          stockType
        }
        searchTraces {
          stockIdentifier {
            brand
            country
            language
            stockCarsType
          }
          criteria {
            id
            items
          }
          specialCriteria {
            id
            items
          }
          sort {
            id
            direction
          }
        }
        warnings {
          code
          message
        }
      }
    }
  }
`;
